import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InternalErrorBoundaryRenderer from "./components/InternalErrorBoundaryRenderer";
export class ErrorBoundary extends React.Component {
    state = {};
    static getDerivedStateFromError(error) {
        return { error };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.children !== state.children) {
            return {
                children: props.children,
                error: undefined,
            };
        }
        return state;
    }
    render() {
        const { fallback, children } = this.props;
        const { error } = this.state;
        return (_jsx(InternalErrorBoundaryRenderer, { error: error, errorComponent: fallback, children: children }));
    }
}
export default ErrorBoundary;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JCb3VuZGFyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Vycm9yQm91bmRhcnkvRXJyb3JCb3VuZGFyeS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sS0FBb0IsTUFBTSxPQUFPLENBQUM7QUFDekMsT0FBTyw2QkFBNkIsTUFBTSw0Q0FBNEMsQ0FBQztBQUd2RixNQUFNLE9BQU8sYUFBYyxTQUFRLEtBQUssQ0FBQyxTQUd4QztJQUNRLEtBQUssR0FBdUIsRUFBRSxDQUFDO0lBRS9CLE1BQU0sQ0FBQyx3QkFBd0IsQ0FBQyxLQUFZO1FBQ2pELE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQztJQUNuQixDQUFDO0lBRU0sTUFBTSxDQUFDLHdCQUF3QixDQUNwQyxLQUFpQixFQUNqQixLQUF5QjtRQUV6QixJQUFJLEtBQUssQ0FBQyxRQUFRLEtBQUssS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDO1lBQ3RDLE9BQU87Z0JBQ0wsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRO2dCQUN4QixLQUFLLEVBQUUsU0FBUzthQUNqQixDQUFDO1FBQ0osQ0FBQztRQUVELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVNLE1BQU07UUFDWCxNQUFNLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7UUFDMUMsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7UUFFN0IsT0FBTyxDQUNMLEtBQUMsNkJBQTZCLElBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxjQUFjLEVBQUUsUUFBUSxZQUNsRSxRQUFRLEdBQ3FCLENBQ2pDLENBQUM7SUFDSixDQUFDO0NBQ0Y7QUFFRCxlQUFlLGFBQWEsQ0FBQyJ9